
const config = {
    dev: {
        baseWebSocket: `wss://test-qas.fdzq.com/quote`,
        authConf: {
            'OrgCode': 'rh',
            'Token': '4211e33b-5175-4e9e-ad67-1982ea318caf',
            'AppName': 'htzpc',
            'AppVer': 'v1.0.0',
            'AppType': 'pc',
            'Tag': 'af91c60a-1acc-4150-9014-d11086cb9489'
        },
    },
    test: {
        baseWebSocket: `wss://test-qas.fdzq.com/quote`,
        authConf: {
            'OrgCode': 'rh',
            'Token': '4211e33b-5175-4e9e-ad67-1982ea318caf',
            'AppName': 'htzpc',
            'AppVer': 'v1.0.0',
            'AppType': 'pc',
            'Tag': 'af91c60a-1acc-4150-9014-d11086cb9489'
        },
    },
    production: {
        baseWebSocket: `wss://qas.sylapp.cn/quote`,
        authConf: {
            'OrgCode': 'rh',
            'Token': 'e9252a64-6ac8-4bf8-9725-6f106f682908',
            'AppName': 'htzpc',
            'AppVer': 'v1.0.0',
            'AppType': 'pc',
            'Tag': 'af91c60a-1acc-4150-9014-d11086cb9489'
        },
    }
}

module.exports = config[process.env.NODE_ENV]
